import { isSome } from 'fp-ts/lib/Option';
import { constant } from 'fp-ts/lib/function';
import { find } from './utils';
/**
 * Find the active view from a list of PageViews.
 */
const active = find(v => v.isActive());
/**
 * Get the first showable view from a list of options.
 */
const showable = find(v => v.canShow());
/**
 * Form a set of views info a ResponsivePage.
 */
export const createResponsivePage = viewList => {
    const primary = viewList.head;
    const views = viewList.toArray();
    return {
        name: primary.name,
        views,
        isActive: () => isSome(active(views)),
        activate: () => showable(views).getOrElse(constant(primary)).activate()
    };
};
/**
 * Pointfree page activation.
 */
export const activate = (page) => page.activate();
/**
 * Pointfree page status query.
 */
export const isActive = (page) => page.isActive();
